module.exports = __webpack_public_path__ + "static/specialOfferBtnImg-38b88f4a4aefe78fcf1967ba25d2fccf.svg";